import type { MuxPlayerProps } from "@mux/mux-player-react";
import MuxPlayerReact from "@mux/mux-player-react/lazy";
import { usePostHog } from "posthog-js/react";
import React from "react";

interface MuxPlayerLazyProps extends MuxPlayerProps {
  loading?: boolean;
}

export const MuxPlayer = React.forwardRef<React.ElementRef<typeof MuxPlayerReact>, MuxPlayerLazyProps>(
  ({ style = {}, onPlay, ...props }, ref) => {
    const posthog = usePostHog();

    return (
      <MuxPlayerReact
        ref={ref}
        streamType="on-demand"
        {...props}
        disableCookies
        onPlay={(e) => {
          posthog.capture("video_played", {
            title: props.title,
            id: props.playbackId,
          });
          onPlay?.(e);
        }}
        style={{
          // @ts-expect-error - this is valid
          "--media-accent-color": "#047857",
          ...style,
        }}
      />
    );
  }
);

MuxPlayer.displayName = "MuxPlayer";
